<!-- ProductListBody.vue -->
<template>
	<div class="ui-product-body">
		<div class="list" v-on:click='goDetail()'>

			<div class="ui-image-wrapper">
				<img src="../../../assets/image/change-icon/default_image_02@2x.png" class="product-img" v-if='isPhotoEmpty(item)'>
				<img class="product-img" v-bind:src="getPhotoUrl(item)" v-if='!isPhotoEmpty(item)' data-src='../../../assets/image/change-icon/default_image_02@2x.png' >
				<span v-if="item.good_stock == 0 ">已售罄</span>
				<span v-if="item.good_stock > 0 && item.good_stock <= 10">仅剩{{ Number(item.good_stock) }}件</span>
			</div>

			<div class="flex-right">
				<div class="product-header">
	              	<img class="promos-icon" v-if="(item.promos && item.promos.length > 0) || item.flashsale ||  item.discount" src="../../../assets/image/change-icon/c0_sale@2x.png" />
					<h3 class="title clear-bottom" style="-webkit-box-orient:vertical">{{ item.name }}</h3>
				</div>
				<span class="sub-title" style="-webkit-box-orient:vertical">{{ item.desc }}</span>
				<div class="price">
					<span>￥{{ utils.currencyPrice(item.shop_price) }}</span>
					<!-- <span>￥{{ utils.currencyPrice(item.price)}}</span> -->
				</div>
				<div class="flashsale">
					<span style="font-size: 16px;color:red;">限时抢购价格:￥{{ (item.flashsale|| {}).flashsale_price }}</span>
				</div>
				<div class="flashsale">
					<span style="font-size: 12px;color:red;">时间区间:{{getTime((item.flashsale|| {}).flashsale_start_at)}}~{{getTime((item.flashsale|| {}).flashsale_end_at)}}</span>
				</div>
				<div class="sendway">
					<span v-if="item.self_employed" class="self-support">自营</span>
					<span v-if="item.flashsale && item.flashsale.limit_amount">限购{{item.flashsale.limit_amount}}件</span>
					<span v-if="item.review_rate">{{item.review_rate}}好评</span>
					<span v-if="item.sales_count">销量{{item.sales_count}}</span>
					<span v-if="cartAddType == 2"><div class="ui-number">
						<div class="reduce ui-common" @click.stop="reduceNumber()" v-bind:class="{'reduce-opacity': numbers <= 1}">-</div><input type="number" min="1" :max="item.good_stock" class="number" value="1" v-model="numbers" :disabled="isPeriodCard?true:false"><div class="add ui-common" @click.stop="addNumber()" v-bind:class="{'reduce-opacity': isPeriodCard}">+</div>
					</div></span>
					<!-- <img src="../../../assets/image/change-icon/b1_add_cart@2x.png" @click.stop="_cartAdd(item.id)"> -->
					<img src="../../../assets/image/change-icon/add@2x.png" @click.stop="_cartAdd(item.id)">
				</div>
			</div>
		</div>
		<shopping v-if='isShowcartInfo && showCartInfo(item, cartAddType)' :isShowcartInfo="isShowcartInfo" ></shopping>
		<!-- 加入购物车显示动画 -->
		<div class="ui-cart-animation" v-if='isAnimation'>
			<mt-spinner type="snake" color='#FA800A'></mt-spinner>
		</div>
	</div>
</template>

<script>
import { Toast, Indicator, Spinner } from 'mint-ui';
import { mapState, mapMutations } from 'vuex';
import { cartAdd } from '../../../api/cart';
import shopping from '../../product-detail/child/Shopping';
import { productGet } from '../../../api/product';

export default{
	data(){
		return{
			isAnimation: false, //加入购物车成功之后是否显示动画
			numbers: 1,
      toastConfig: {
        message: '商品达到每单限购数量',
        position: 'middle'
      },
		}
	},
  components: {
    shopping
  },
	props: ['item', 'productId', 'cartAddType', 'requestparams'],

	computed: {
		...mapState({
			isOnline: state => state.auth.isOnline,
      //开关，是否显示购物车浮层
      isShowcartInfo: state => state.detail.isShowcartInfo,
		}),
	},

  created() {
    this.$on('start-addcart-animation', () => {
      this.isAnimation = true;
    });
    this.$on('end-addcart-animation', () => {
      this.isAnimation = false;
      this.saveCartState(false);
console.log("ProductListBody.vue / end-addcart-animation")
			Toast({message: '加入成功', position: 'middle', duration: 3000});
    });
  },

  watch: {
    numbers: function(value) {
      if (value) {
        let good_stock = Number(this.item.good_stock);
console.log("ProductListBody.vue / watch / numbers / good_stock : ", this.item.good_stock);
        if (value <= 0) {
          this.numbers = 1;
          this.toastConfig.message = '受不了了，宝贝不能再少了';
          Toast(this.toastConfig);
        } else if (value > good_stock) {
          this.toastConfig.message = '商品库存不足';
          Toast(this.toastConfig);
          this.numbers = good_stock;
        } else if (this.item.limit_amount > 0 && value > this.limit_amount) {
          this.toastConfig.message = '该商品限购 '+ this.item.limit_amount;
          Toast(this.toastConfig);
          this.numbers = this.item.limit_amount;
        }
        // this.saveNumber(this.numbers);
      }
    }
  },

	methods: {
		...mapMutations({
			saveCartState: 'saveCartState',
			changeType: 'changeType',
				saveInfo: 'saveDetailInfo',
				setCurrentProductId: 'setCurrentProductId',
				saveExchangeScoreState: 'saveExchangeScoreState',
				saveNumber: 'saveNumber',
		}),
		showCartInfo: (item, cartAddType)=>{
			if (cartAddType == 1) {
				// 不显示购物车浮层，直接加入购物车
				return false;
			} else if (cartAddType == 2) {
				// 单规格商品不显示浮层，直接加入购物车，多规格商品显示浮层提示选择规格
				if (item.properties && item.properties.length>0 && item.properties[0].attrs.length > 1) {
					return true;
				} else {
					return false;
				}
			} else {
				// 显示购物车浮层
				return true;
			}
		},
		changeCartState() {
			this.getDetail();
			
			
			console.log("ProductListBody.vue / changeCartState / isShowcartInfo : ", this.isShowcartInfo);
		},
		/*
			getDetail: 获取商品详情， 并且存入状态管理
		*/
		getDetail() {
			this.setCurrentProductId(this.productId);
			productGet(this.productId).then(res => {
				if (res) {
					this.productDetail = res.product;
					this.saveInfo(res.product);
					this.saveNumber(this.numbers);
					this.saveExchangeScoreState(this.productDetail.exchange_score);
console.log("ProductListBody.vue / getDetail / res.product : ", res.product);
					this.saveCartState(true);
					this.changeType('加入购物车');
				}
			})
		},
		getTime(unixTimestamp){
			let date  = new Date(Number(unixTimestamp)*1000)
			let fmt = fmt || 'm-d H:i';
			var map = {
				Y: function() { return date.getFullYear(); },
				m: function() { return (date.getMonth() < 9 ? '0': '') + (date.getMonth() + 1); },
				d: function() { return (date.getDate() < 10 ? '0': '') + date.getDate(); },
				H: function() { return (date.getHours() < 10 ? '0': '') + date.getHours(); },
				i: function() { return (date.getMinutes() < 10 ? '0': '') + date.getMinutes(); },
				s: function() { return (date.getSeconds() < 10 ? '0': '') + date.getSeconds(); }
			};
			var rt = '';
			for(var i=0;i<fmt.length;i++){
				var cur = fmt.charAt(i);
				rt += map[cur] ? map[cur].apply(this): cur;
			}
			return rt;
		},
		isPhotoEmpty(item) {			
			let url = this.getPhotoUrl(item)
			return url && url.length ? false : true
		},
		getPhotoUrl(item) {
			let default_photo = item.default_photo
			if (default_photo) {
				if (default_photo.large) {
					return default_photo.large
				} else if (default_photo.thumb) {
					return default_photo.thumb
				}
			}
			return null
		},
		goDetail() {
			let data = Object.assign({}, {'id': this.productId}, this.requestparams)
			this.$router.push({'name': 'product', 'query': {'id': this.productId}});
		},
    // 数量加
    addNumber() {
      if (this.isPeriodCard) {
        this.numbers = 1;
        this.toastConfig.message = '周期性卡只能一次购买一张哦！';
        Toast(this.toastConfig);
        return;
      }
      if (this.item.good_stock && this.numbers > this.item.good_stock) {
        this.toastConfig.message = '商品库存不足';
        Toast(this.toastConfig);
        this.numbers = this.item.good_stock;
      } else {
        this.numbers++;
      }
    },
    // 数量减
    reduceNumber() {
      if (this.numbers > 1) {
        this.numbers--;
      } else {
        this.numbers = 1;
        this.toastConfig.message = '受不了了，宝贝不能再少了';
        Toast(this.toastConfig);
      }
    },
		/*
		 * cartAdd: 加入购物车
		 * @param： product： 商品id
		*/
		_cartAdd(product) {
			if (this.isOnline) {
				if ( this.showCartInfo(this.item, this.cartAddType) ) {
					this.changeCartState();
				} else {
					// 直接加入购物车
					cartAdd(product, '', this.numbers,this.$store.getters.getUser.id).then(res => {
						if (res) {
							this.$parent.$emit('get-cart-quantity');
							Toast({message: '加入成功', position: 'middle', duration: 5000});
						}
					}, (error) => {
						Toast('请求异常:'+error.errorMsg);
					});
				}

			} else {
				this.$router.push({'name': 'signin'});
			}
		},
	}
}
</script>

<style lang='scss' scoped>
.ui-product-body {
	border-bottom: 1px solid rgba(232,234,237,1);
	.list {
		display: flex;
		width: auto;
		align-items: center;
		justify-content: space-between;
		margin: 11px 10px;
		position: relative;
		div.ui-image-wrapper {
			width: 110px;
			height: 110px;
			position: relative;

			display: flex;
		    justify-content: center;
		    align-content: center;
		    align-items: center;
			flex-basis: 110px;
			flex-shrink: 0;

			background-position:center center!important;
		    background: url("../../../assets/image/change-icon/default_image_02@2x.png");
		    background-size:100px 100px;
		    background-repeat:no-repeat;
		    -webkit-background-size: cover;
		    -moz-background-size: cover;
		    -o-background-size: cover;
		    background-size: cover;

			img.product-img{
				width: 110px;
				height: 110px;
				flex-basis: 110px;
				flex-shrink: 0;
			}
			img.product-img[lazy=loading] {
				width: 30px;
				height: 30px;
			}
			img.product-im[lazy=error] {
				width: 30px;
				height: 30px;
			}
			img.product-img[lazy=loaded] {
				width: 110px;
				height: 110px;
				flex-basis: 110px;
				flex-shrink: 0;
				background:rgba(255,255,255,1);
			}

			span {
				position: absolute;
				height:20px;
				background:rgba(243,244,245,1);
				line-height: 20px;
				text-align: center;
				font-size:14px;
				color:$primaryColor;
				width: 110px;
				bottom: 0px;
				left: 0px;
			}
		}

		span.promos {
			position: absolute;
			background: url('../../../assets/image/change-icon/label@2x.png') no-repeat;
			width: 36px;
			height: 19px;
			color: #FFFFFF;
			font-size: 10px;
			top: 0px;
			left: 0px;
			background-size: cover;
			font-weight: 100;
			line-height: 19px;
			text-align: left;
			padding-left: 5px;
		}
		.flex-right {
			padding-left: 14px;
			width: 100%;
			.title {
				color: #4E545D;
				font-size: 16px;
				font-weight: normal;

				display:-moz-box;
			  display:-webkit-box;
			    display:box;

				-webkit-line-clamp: 2;
				-moz-line-clamp: 2;

				-moz-box-orient:vertical;
				-webkit-box-orient:vertical;
				box-orient:vertical;

				overflow: hidden;
				margin-bottom: 8px;
				&.clear-bottom {
					margin-bottom: 0px;
				}
			}

			.product-header {
				display: flex;
	            align-items: center;
			}
			.promos-icon {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
			.sub-title {
				color: #55595F;
				font-size: 12px;

				display:-moz-box;
			  display:-webkit-box;
			  display:box;

				-webkit-line-clamp: 1;
				-moz-line-clamp: 1;

				-moz-box-orient:vertical;
				-webkit-box-orient:vertical;
				box-orient:vertical;

				overflow: hidden;
				margin-bottom: 8px;
			}
			.price {
				margin-bottom: 8px;
				span {
					&:first-child {
						color: $primaryColor;
						font-size: 16px;
						text-decoration: line-through;
					}
					// &:last-child {
					// 	color: #A4AAB3;
					// 	font-size: 12px;
					// 	text-decoration: line-through;
					// }
				}
			}
			.flashsale {
				margin-bottom: 8px;
				span {
					&:first-child {
						color: $primaryColor;
						font-size: 12px;
					}
				}
			}
			.sendway {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 12px;
				font-weight: 'Regular';
				span{
					color: #7C7F88;
					&.self-support {
						font-size: 10px;
						color: $primaryColor;
						border: 1px solid $primaryColor;
						border-radius: 2px;
						width: 32px;
					    height: 16px;
					    line-height: 16px;
					    text-align: center;
					}
				}
				img {
					width: 22px;
					height: 20px;
				}

				div.ui-number {
					height: 30px;
					display: flex;
					border-radius: 3px 0px 0px 3px;
					input,
					div {
						height: 28px;
						text-align: center;
						color: #404245;
						display: inline-block;
						padding: 0px;
						margin: 0px;
						border: 0px;
						outline-offset: 0px;
					}
					.ui-common {
						line-height: 28px;
						width: 28px;
						height: 28px;
						border: 1px solid #c7c7cd;
						cursor: pointer;
					}
					.reduce {
						border-right: 0px;
					}
					.reduce-opacity {
						opacity: 0.4;
					}
					.add {
						border-left: 0px;
					}
					input[type='number'] {
						width: 28px;
						border: 1px solid #c7c7cd;
						border-radius: 0px;
						border-image-width: 0px;
						box-shadow: 0px;
						vertical-align: bottom;
						&:focus {
							outline: none;
						}
					}
				}

			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/page/flashsale-list/child/ProductListBody.vue